module.exports = "/images/collaboration-not-available.30c3f1a15b4838afacd5caea40f80155.jpg";